export default theme => ({
	mobileMedia: {
		background: "#000"
	},
	icon: {
		cursor: "pointer",
		width: "11%",
		marginLeft: "5px",
		height: "100vh"
	},
	mediaIcons: {
		textAlign: "center"
	},
	mediaSlideShow: {
		top: "55px",
		left: 0,
		right: 0,
		width: "100vw",
		bottom: 0,
		height: "100vh",
		zIndex: 1205,
		position: "fixed",
		background: "rgba(0,0,0,.7)",
		alignItems: "center",
		display: "flex",
		"& .image-gallery": {
			width: "100%",
			marginTop: "24px",
			"& :focus": {
				outline: "none"
			}
		},
		"& h6": {
			top: "5px",
			position: "absolute",
			marginLeft: "auto",
			marginRight: "auto",
			color: "white",
			left: 0,
			right: 0,
			textAlign: "center",
			fontSize: "30px",
			margin: 0,
			textTransform: "capitalize"
		}
	},
	closeSlideShowBtn: {
		position: "absolute",
		top: 0,
		right: "26px",
		color: "#fff"
	}
});
